import { http } from '@/network/http';
import type {
  Hospital,
  HospitalFormData,
  HospitalListFilters,
  HospitalListResponse,
  HospitalDetail,
  TherapistAssignment,
  HospitalBonus,
  HospitalBonusFormData,
} from './types';

export const hospitalApi = {
  list: (filters?: HospitalListFilters) =>
    http.get<HospitalListResponse>('/hospitals', { params: filters }),

  getById: (id: string) =>
    http.get<{ success: boolean; hospital: HospitalDetail }>(`/hospitals/${id}`),

  create: (data: HospitalFormData) =>
    http.post<{ success: boolean; hospital: Hospital }>('/hospitals', data),

  update: (id: string, data: Partial<HospitalFormData>) =>
    http.put<{ success: boolean; hospital: Hospital }>(`/hospitals/${id}`, data),

  deactivate: (id: string) =>
    http.delete<{ success: boolean }>(`/hospitals/${id}`),

  listMy: () =>
    http.get<{ success: boolean; hospitals: Hospital[] }>('/hospitals/me'),

  listMap: () =>
    http.get<{ success: boolean; hospitals: Hospital[] }>('/hospitals/map'),

  getTherapists: (id: string) =>
    http.get<{ success: boolean; therapists: TherapistAssignment[] }>(`/hospitals/${id}/therapists`),

  assignTherapist: (hospitalId: string, therapistId: string, isPrimary?: boolean) =>
    http.post<{ success: boolean }>(`/hospitals/${hospitalId}/therapists`, { therapistId, isPrimary }),

  unassignTherapist: (hospitalId: string, therapistId: string) =>
    http.delete<{ success: boolean }>(`/hospitals/${hospitalId}/therapists/${therapistId}`),

  // Hospital Bonuses
  getHospitalBonuses: (hospitalId: string) =>
    http.get<{ success: boolean; bonuses: HospitalBonus[] }>(`/hospitals/${hospitalId}/bonuses`),

  createHospitalBonus: (hospitalId: string, data: HospitalBonusFormData) =>
    http.post<{ success: boolean; bonus: HospitalBonus }>(`/hospitals/${hospitalId}/bonuses`, data),

  updateHospitalBonus: (hospitalId: string, bonusId: string, data: { bonusAmount: number }) =>
    http.put<{ success: boolean; bonus: HospitalBonus }>(`/hospitals/${hospitalId}/bonuses/${bonusId}`, data),

  deleteHospitalBonus: (hospitalId: string, bonusId: string) =>
    http.delete<{ success: boolean }>(`/hospitals/${hospitalId}/bonuses/${bonusId}`),
};
